import { Directive, ElementRef, Input, HostListener } from '@angular/core';

@Directive({
  selector: '[appAutoFocusOnEvent]'
})
export class AutoFocusOnEventDirective {
  @Input('appAutoFocusOnEvent') triggerEventName!: string;

  constructor(private el: ElementRef) { }

  @HostListener('document:click', ['$event'])
  onClick(event: MouseEvent) {
    let target = event.target as HTMLElement;

    // Traverse up to find the element with the trigger
    while (target) {
      if (target.getAttribute && target.getAttribute('data-focus-trigger') === this.triggerEventName) {
        setTimeout(() => this.el.nativeElement.focus(), 0);
        break;
      }
      target = target.parentElement!;
    }
  }
}
